import * as React from 'react';

import { useSpecializationPageData } from 'bundles/unified-description-page-common/contexts/consumer/ConsumerBffSpecializationContext';
import type { DegreesByDomainData } from 'bundles/unified-description-page-common/hooks/useDegreesByDomain';
import useDegreesByDomain from 'bundles/unified-description-page-common/hooks/useDegreesByDomain';

const DegreeCollectionContext = React.createContext<DegreesByDomainData>({
  degrees: [],
  degreesLoading: true,
});

type Props = {
  children: React.ReactNode;
};

export const useSpecializationDegreeCollection = () => React.useContext(DegreeCollectionContext);

const SpecializationDegreeCollectionDataProvider = ({ children }: Props) => {
  const pageData = useSpecializationPageData();
  const degreesByDomainData = useDegreesByDomain(
    pageData?.domains?.filter(Boolean).map((domain) => domain.domainId) ?? []
  );
  return <DegreeCollectionContext.Provider value={degreesByDomainData}>{children}</DegreeCollectionContext.Provider>;
};

export default SpecializationDegreeCollectionDataProvider;
